<template>
    <OtherEmail v-if="selected_page == 'other_email'" @switchPage="switchPage" />
    <MeritiosEmail v-else-if="selected_page == 'meritios_email'" @switchPage="switchPage" />
</template>

<script>
import { eventBus } from "@/main";
import OtherEmail from "./OtherEmail/index.vue";
import MeritiosEmail from "./MeritiosEmail/index.vue";

export default {
    name: "Emails",
    components: {
        OtherEmail,
        MeritiosEmail
    },
    props: {},
    data: () => {
        return {
            selected_page: "meritios_email"
        };
    },
    mounted() {
    },
    computed: {},
    watch: {},
    methods: {
        switchPage(page) {
            this.selected_page = page;
        }
    },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
</style>
